export const SESSION_STORAGE_SHOW_NOTIFY_ME_WARNING_KEY =
  "Asos.SavedLists.ShowNotifyMeWarning";
export const IDENTITY_REDIRECT_PATH = "web/pages/identity-redirect";
